export default {
    state: {
        adminLoggedIn: false,
        checkingForLogin: true,
        userLogin: "",
        userPassword: ""
    },
    getters: {
        getCheckingForLogin: state => state.checkingForLogin,
        getLoginState: state => state.adminLoggedIn,
    },
    mutations: {
        // loginData_checkForLogin(state) {
        //     state.checkingForLogin = false;
        // }
    },
    actions: {
        // loginData_checkForLogin(ctx) {
        //     ctx.commit('loginData_checkForLogin');
        // }
    },
}

import socketIoAPI from '@/modules/socketAPI.js'
import vueAPI from '@/modules/vueAPI.js'

import siteLangs from '@/packages/socket/getSiteLangs.js'
import pingSubscription from '@/packages/socket/pingSubscription.js'
import getMyData from '@/packages/socket/getMyData.js'

socketIoAPI.onNewConnection(function(socketVar) {
    socketVar.on("connect", () => {
        console.log("Connected to server!");
        let timestampNow = Date.now()
        let thisCookiesLoginToken = Cookies.get('adlgn_t')
        if (thisCookiesLoginToken && thisCookiesLoginToken.length >= 32) {
            socketVar.emit('adminAuth', timestampNow, thisCookiesLoginToken, device, function(returnData) {
                // console.log(`Return data: ${JSON.stringify(returnData)}`)
                vueAPI.onMounted(function(thisVue) {
                    if (returnData.response.success == true) {
                        Cookies.set('adlgn_t', thisCookiesLoginToken, { expires: 30 })
                        thisVue.$store.state.loginData.adminLoggedIn = true
                    } else {
                        thisVue.$store.state.loginData.adminLoggedIn = false
                    }
                    thisVue.$store.state.loginData.checkingForLogin = false
                })
            })
        } else {
            vueAPI.onMounted(function(thisVue) {
                thisVue.$store.state.loginData.adminLoggedIn = false
                thisVue.$store.state.loginData.checkingForLogin = false
            })
        }
    })

    socketVar.on("refreshLoginToken", (callback) => {
        let thisCookiesLoginToken = Cookies.get('adlgn_t')
        if (thisCookiesLoginToken && thisCookiesLoginToken.length >= 32) {
            callback(thisCookiesLoginToken)
        }
    })
})

socketIoAPI.onNewConnection(function(socketVar) {
    socketVar.on('allOnlineUsers', function(thisUsersdata) {
        vueAPI.onMounted(function(thisVue) {
            thisUsersdata.forEach(thisUser => {
                thisVue.$store.state.socket.connectedUsers[`uid-${thisUser.user_id}`] = thisUser
            });
        })
    })

    socketVar.on('adminLogin', function(thisUserDBData) {
        vueAPI.onMounted(function(thisVue) {
            if (thisVue.$store.state.socket.connectedUsers.hasOwnProperty(`uid-${thisUserDBData.id}`)) {
                thisVue.$store.state.socket.connectedUsers[`uid-${thisUserDBData.id}`].sessions_count++
            } else {
                thisVue.$store.state.socket.connectedUsers[`uid-${thisUserDBData.id}`] = {
                    user_id: thisUserDBData.id,
                    sessions_count: 1
                }
            }
        })
    })

    socketVar.on('adminLogout', function(thisUserDBID, sessionsLeft) {
        vueAPI.onMounted(function(thisVue) {
            if (thisVue.$store.state.socket.connectedUsers.hasOwnProperty(`uid-${thisUserDBID}`)) {
                if (sessionsLeft <= 0) {
                    delete thisVue.$store.state.socket.connectedUsers[`uid-${thisUserDBID}`]
                } else {
                    thisVue.$store.state.socket.connectedUsers[`uid-${thisUserDBID}`].sessions_count = sessionsLeft
                }
            }
        })
    })

    socketVar.on('adminSessionLogout', function() {
        console.log('Logging out')
        vueAPI.onMounted(function(thisVue) {
            thisVue.$store.state.loginData.adminLoggedIn = false
        })
    })
})